document.addEventListener('alpine:init', () => {
    Alpine.data('deleteAsset', () => ({
        assetId: '',
        token: '',
        removeAsset(e) {
            let data = {}

            data['assetId'] = this.assetId
            data['CRAFT_CSRF_TOKEN'] = this.token

            // console.log(data)

            fetch('/actions/assets/delete-asset', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
            .then(() => {
                document.location.reload(true)
            })
            .catch(() => {
                this.status = 'Sorry. Request failed.'
            })
        },
    }))
})
